

/**
* 文字列チェック
* nullかどうか
* @param value チェック対象文字列
* @return {boolean}
*  true:null、
*  false:nullではない
**/
export function checkStrIsNull(value) {
    return value == null
}

/**
 * エラーメッセージ取得
 * nullエラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrIsNull(
  propertyName) {
  return propertyName + 'は必須入力です。'
}

/**
* 文字列チェック
* 空文字かどうか
* @param value チェック対象文字列
* @return {boolean}
*  true:空文字、
*  false:空文字ではない
**/
export function checkStrIsKaraMoji(value) {
  return '' == value
}

/**
 * エラーメッセージ取得
 * 空文字エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrIsKaraMoji(
  propertyName) {
  return propertyName + 'は必須入力です。'
}

/**
 * 文字列チェック
 * 文字列の長さが適正値
 * @param value チェック対象文字列
 * @param length 適正な文字列の長さ
 * @return {boolean}
 *  true:文字列の長さと一致、
 *  false:文字列の長さと一致しない
 **/
export function checkStrLength(value, length) {
  return value.length == length
}

/**
 * エラーメッセージ取得
 * 文字列の長さが不正エラー
 * @param propertyName チェック対象項目名
 * @param strlength 適正な文字列の長さ
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrLength(
  propertyName,strlength) {
  return propertyName + 'は' + strlength + '桁で入力ください。'
}

/**
 * 文字列チェック
 * 最小文字数以上を満たしているか
 * @param value チェック対象文字列
 * @param length 最小文字数
 * @return {boolean}
 *  true:最小文字数以上、
 *  false:最小文字数より小さい
 **/
export function checkStrMinLength(value, length) {
  return value.length >= length
}

/**
 * エラーメッセージ取得
 * 最小文字数以上エラー
 * @param propertyName チェック対象項目名
 * @param strMinLength 最小文字数
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMinLength(
  propertyName, strMinLength) {
  return propertyName + 'は' + strMinLength + '桁以上で入力ください。'
}

/**
 * 文字列チェック
 * 最大文字数以下を満たしているか
 * @param value チェック対象文字列
 * @param length 最大文字数
 * @return {boolean}
 *  true:最大文字数以下、
 *  false:最大文字数より大きい
 **/
export function checkStrMaxLength(value, length) {
  return value.length <= length
}

/**
 * エラーメッセージ取得
 * 最大文字数以下エラー
 * @param propertyName チェック対象項目名
 * @param strMaxLength 最大文字数
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMaxLength(
  propertyName, strMaxLength) {
  return propertyName + 'は' + strMaxLength + '桁以下で入力ください。'
}

/**
 * 文字列チェック
 * 最小文字数以上を満たしているか
 * 最大文字数以下を満たしているか
 * @param value チェック対象文字列
 * @param minlength 最小文字数
 * @param maxlength 最大文字数
 * @return {boolean}
 *  true:最小文字数以上かつ最大文字数以下、
 *  false:最小文字数以上かつ最大文字数以下のいずれかを満たさない
 **/
export function checkStrMinMaxLength(value, minlength, maxlength) {
  return checkStrMinLength(value, minlength)
    && checkStrMaxLength(value, maxlength)
}

/**
 * エラーメッセージ取得
 * 最小最大文字数以下エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMinMaxLength(
  propertyName) {
  return propertyName + 'は適正な文字数はありません。'
}

/**
 * 文字列のバイト数を取得
 * Shift_JISで単純に半角１バイト全角２バイトで計算する
 * @param value 対象文字列
 * @returns バイト数
 */
export function getStrByteLengthByShiftJis(value) {
  var tempByteLength = 0
  for(var i=0;i<value.length;i++) {
      // 1文字ずつ文字コード（UTF-16）を取得
      // ABあいなら「65,66,12354,12356」（10進数）を返しそれぞれ「0x41,0x42,省略,省略」（16進数）「A,B,あ,い」を表す
      var tempUTFCode = value.charCodeAt(i)
      // Shift_JISなら半角の文字コード
      if((tempUTFCode >= 0x0 && tempUTFCode < 0x81) || (tempUTFCode === 0xf8f0)
           || (tempUTFCode >= 0xff61 && tempUTFCode < 0xffa0) || (tempUTFCode >= 0xf8f1 && tempUTFCode < 0xf8f4))
      {
          tempByteLength += 1
      } else {
          tempByteLength += 2
      }
  }
  return tempByteLength
}

/**
 * 文字列チェック
 * 文字列のバイト数が適正値
 * @param value チェック対象文字列
 * @param byteLength 適正なバイト数
 *  true:文字列のバイト数と一致、
 *  false:文字列のバイト数と一致しない
 */
export function checkStrByteLength(
  value, byteLength){
  var tempByteLength = getStrByteLengthByShiftJis(value)
  return tempByteLength == byteLength
}

/**
 * エラーメッセージ取得
 * 最小バイト数の長さが不正エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrByteLength(
    propertyName) {
    return propertyName + 'が適正な文字数ではありません。'
}

/**
 * 文字列チェック
 * 最小バイト数以上を満たしているか
 * @param value チェック対象文字列
 * @param byteLength 最小バイト数
 * @return {boolean}
 *  true:最小バイト数以上、
 *  false:最小バイト数より小さい
 **/
export function checkStrMinByteLength(value, byteLength) {
    var tempByteLength = getStrByteLengthByShiftJis(value)
    return tempByteLength >= byteLength
}

/**
 * エラーメッセージ取得
 * 最小バイト数以上エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMinByteLength(
    propertyName) {
    return propertyName + 'の入力文字数が少なすぎます。'
}

/**
 * 文字列チェック
 * 最大バイト数以下を満たしているか
 * @param value チェック対象文字列
 * @param byteLength 最大バイト数
 * @return {boolean}
 *  true:最大バイト数以下、
 *  false:最大バイト数より大きい
 **/
export function checkStrMaxByteLength(value, byteLength) {
    var tempByteLength = getStrByteLengthByShiftJis(value)
    return tempByteLength <= byteLength
}

/**
 * エラーメッセージ取得
 * 最大文字数以下エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMaxByteLength(
    propertyName) {
    return propertyName + 'の入力文字数が多すぎます。'
}

/**
 * 文字列チェック
 * 最小バイト数以上を満たしているか
 * 最大バイト数以下を満たしているか
 * @param value チェック対象文字列
 * @param minBytelength 最小バイト数
 * @param maxBytelength 最大バイト数
 * @return {boolean}
 *  true:最小バイト数以上かつ最大バイト数以下、
 *  false:最小バイト数以上かつ最大バイト数以下のいずれかを満たさない
 **/
export function checkStrMinMaxByteLength(value, minBytelength, maxBytelength) {
    return checkStrMinByteLength(value, minBytelength)
        && checkStrMaxByteLength(value, maxBytelength)
}

/**
 * エラーメッセージ取得
 * 最小最大バイト数以下エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrMinMaxByteLength(
    propertyName) {
    return propertyName + 'が適正な文字数ではありません。'
}

/**
* 文字列チェック
* 正規表現で半角英数を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:半角英数を満たす、
*  false:半角英数を満たさない
**/
export function checkStrHalfWidthAlphaNumeric(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[a-zA-Z0-9]+$','i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 半角英数書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrHalfWidthAlphaNumeric(
  propertyName) {
  return propertyName + 'は半角英数で入力してください。'
}

/**
* 文字列チェック
* 正規表現で半角英字を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:半角英字を満たす、
*  false:半角英字を満たさない
**/
export function checkStrHalfWidthAlpha(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[a-zA-Z]+$', 'i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 半角英字書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrHalfWidthAlpha(
  propertyName) {
  return propertyName + 'は半角英字で入力してください。'
}

/**
* 文字列チェック
* 正規表現で半角数字を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:半角数字を満たす、
*  false:半角数字を満たさない
**/
export function checkStrHalfWidthNumeric(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[0-9]+$','i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 半角数字書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrHalfWidthNumeric(
  propertyName) {
  return propertyName + 'は半角数字で入力してください。'
}

/**
* 文字列チェック
* 正規表現で英字名（半角英数 + スペース）を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:英字名を満たす、
*  false:英字名を満たさない
**/
export function checkStrEnglishName(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[a-zA-Z0-9 ]+$','i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 半角英字名書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrEnglishName(
  propertyName) {
  return propertyName + 'に使用できない文字が入力されています。'
}

/**
 * パスワードチェック
 * @param value チェック対象文字列
 * @returns {boolean}
 */
export function checkStrPassword(value) {
  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[a-zA-Z0-9@#%&!\$\?]+$','i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * パスワード書式エラー
 * @param {*} propertyName チェック対象項目名
 * @returns {string}
 *  エラーメッセージ
 */
export function getErrorMessageCheckStrPassword(
  propertyName) {
  return propertyName + 'に使用できない文字が入力されています。'
}

/**
* 文字列チェック
* 日付形式を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:日付形式を満たす、
*  false:日付形式を満たさない
**/
export function checkStrDate(year, month, date) {

  var tempDate = new Date(year, month, date)

  if (tempDate.getFullYear() != year
    || tempDate.getMonth() != month
    || tempDate.getDate() != date) {
    return false
  }
  return true
}

/**
 * エラーメッセージ取得
 * 日付形式書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrDate(
  propertyName) {
  return propertyName + 'は日付形式で入力してください。'
}

/**
* 文字列チェック
* 正規表現で郵便番号の書式（999-9999）(3桁)-(4桁)を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:郵便番号の書式を満たす、
*  false:郵便番号の書式を満たさない
**/
export function checkStrZipCode(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[0-9]{3}[-][0-9]{4}$', 'i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 郵便番号書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrZipCode(
  propertyName) {
  return propertyName + 'が正しい書式ではありません。'
}

/**
* 文字列チェック
* 正規表現で電話番号の書式（99999-9999-9999）ハイフンは任意
* @param value チェック対象文字列
* @return {boolean}
*  true:電話番号の書式を満たす、
*  false:電話番号の書式を満たさない
**/
export function checkStrTel(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[0-9]{2,5}-?[0-9]{1,4}-?[0-9]{4}$', 'i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * 電話番号書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrTel(
  propertyName) {
  return propertyName + 'が正しい書式ではありません。'
}

/**
* 文字列チェック
* 正規表現でEmailの書式を満たしているか
* @param value チェック対象文字列
* @return {boolean}
*  true:Emailの書式を満たす
*  false:Emailの書式を満たさない
**/
export function checkStrEmail(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^[A-Za-z0-9_\\-\\.]+@[A-Za-z0-9_\\-\\.]+\\.[A-Za-z]+$', 'i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * Email書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrEmail(
  propertyName) {
  return propertyName + 'が正しい書式ではありません。'
}

/**
* 文字列チェック
* 正規表現でURL（「https://」もしくは「http://」）
* @param value チェック対象文字列
* @return {boolean}
*  true:URLの書式を満たす
*  false:URLの書式を満たさない
**/
export function checkStrURL(value) {

  // RegExpオブジェクトの作成
  var regexp = new RegExp('^http(s)?://[A-Za-z0-9!~*();/?:@&=+$,%#\'_\\-\\.]+$','i')

  return regexp.test(value)
}

/**
 * エラーメッセージ取得
 * URL書式エラー
 * @param propertyName チェック対象項目名
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckStrURL(
  propertyName) {
  return propertyName + 'が正しい書式ではありません。'
}

/**
 * 整数チェック
 * 最小値以上を満たしているか
 * @param value チェック対象数値
 * @param min 最小値
 * @return {boolean}
 *  true:最小値以下を満たす、
 *  false:最小値以下を満たさない
 **/
export function checkNumberMinRange(value, min) {
  return value >= min
}

/**
 * エラーメッセージ取得
 * 最小値以上エラー
 * @param propertyName チェック対象項目名
 * @param min 最小値
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckNumberMinRange(
  propertyName, min) {
  return propertyName + 'は' + String(min) + '以上で入力してください'
}

/**
 * 整数チェック
 * 最大値以下を満たしているか
 * @param value チェック対象数値
 * @param max 最大値
 * @return {boolean}
 *  true:最大値以下を満たす、
 *  false:最大値以上を満たさない
 **/
export function checkNumberMaxRange(value, max) {
  return value <= max
}

/**
 * エラーメッセージ取得
 * 最大値以下エラー
 * @param propertyName チェック対象項目名
 * @param max 最小値
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckNumberMaxRange(
  propertyName, max) {
  return propertyName + 'は' + String(max) + '以下で入力してください'
}

/**
 * 整数チェック
 *  最小値以上を満たしているか
 * 最大値以下を満たしているか
 * @param value チェック対象数値
 * @param min 最小値
 * @param max 最大値
 * @return {boolean}
 *  true:最大値以下を満たす、
 *  false:最大値以上を満たさない
 **/
export function checkNumberMinMaxRange(value, min, max) {
  return checkNumberMinRange(value, min)
    && checkNumberMaxRange(value, max)
}

/**
 * エラーメッセージ取得
 * 最大値以下エラー
 * @param propertyName チェック対象項目名
 * @param min 最小値
 * @param max 最大値
 * @return {string}
 *  エラーメッセージ
 **/
export function getErrorMessageCheckNumberMinMaxRange(
  propertyName,min, max) {
  return propertyName + 'は' + String(min) + '以上'+ String(max) + '以下で入力してください'
}



// WEBPACK FOOTER //
// ./src/components/Utility/UtilitiValidation.js